// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS POUR LA PAGE SHARE - RESPONSIVE */

/* Styles de base pour la page Share */
.share-container {
  background: #E8FCE2;
  min-height: 100vh;
  padding: 20px 0;
}

.share-form-container {
  max-width: 100%;
  margin: 0 auto;
}

/* Styles pour les cartes de formulaire */
.share-form-card {
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-top: 6px solid #43CE0C;
}

.share-question-card {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #43CE0C;
}

/* Styles pour les boutons */
.share-submit-btn {
  padding: 12px 24px;
  height: auto;
  color: #fff;
  background: linear-gradient(135deg, #43CE0C 0%, #2e9e06 100%);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(67, 206, 12, 0.3);
  transition: all 0.3s ease;
}

.share-submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(67, 206, 12, 0.4);
}

.share-reset-text {
  color: #43CE0C;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s ease;
}

.share-reset-text:hover {
  color: #2e9e06;
  text-decoration: underline;
}

/* RESPONSIVE MOBILE */
@media (max-width: 768px) {
  .share-container {
    padding: 10px;
    background: #E8FCE2;
  }
  
  .share-form-container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 8px;
  }
  
  /* Cartes adaptées mobile */
  .share-form-card {
    margin-bottom: 16px;
    border-radius: 12px;
    padding: 20px 16px;
    border-top: 8px solid #43CE0C;
  }
  
  .share-question-card {
    margin-bottom: 16px;
    border-radius: 10px;
    padding: 16px 12px;
    border-left: 5px solid #43CE0C;
  }
  
  /* Titre du formulaire optimisé mobile */
  .titrFormulaire.ant-input {
    font-size: 20px !important;
    line-height: 1.3 !important;
    margin-top: 0 !important;
    padding: 8px 0 !important;
    text-align: center;
  }
  
  /* Description optimisée mobile */
  .inputDescriptionTitle.ant-input {
    font-size: 14px !important;
    line-height: 1.4 !important;
    text-align: center;
    padding: 4px 0;
  }
  
  /* Labels des questions */
  .share-question-label {
    font-size: 15px !important;
    line-height: 1.4 !important;
    margin-bottom: 12px !important;
    font-weight: 500;
  }
  
  /* SURCHARGE TOUS LES INPUTS DANS LE SHARE CONTAINER */
  .share-container .ant-input,
  .share-container .ant-input-password,
  .share-container .ant-select-selector,
  .share-container .ant-picker,
  .share-container textarea.ant-input {
    width: 100% !important;
    height: 44px !important;
    border-radius: 8px !important;
    border: 2px solid #e2e8f0 !important;
    font-size: 16px !important;
    padding: 0 12px !important;
    background: #f8fafc !important;
    transition: all 0.3s ease !important;
    box-sizing: border-box !important;
  }
  
  /* Textarea spécifique */
  .share-container textarea.ant-input {
    min-height: 80px !important;
    padding: 12px !important;
    resize: vertical !important;
  }
  
  /* Focus states */
  .share-container .ant-input:focus,
  .share-container .ant-input:hover,
  .share-container .ant-input-password:focus,
  .share-container .ant-input-password:hover,
  .share-container .ant-select-focused .ant-select-selector,
  .share-container .ant-picker:hover,
  .share-container .ant-picker-focused,
  .share-container textarea.ant-input:focus,
  .share-container textarea.ant-input:hover {
    border-color: #43CE0C !important;
    background: #fff !important;
    box-shadow: 0 0 0 3px rgba(67, 206, 12, 0.1) !important;
  }
  
  /* Radio buttons optimisés */
  .share-container .ant-radio-group {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  .share-container .ant-radio-wrapper {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    margin: 6px 0 !important;
    padding: 12px 16px !important;
    background: #f8fafc !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    font-size: 15px !important;
    transition: all 0.3s ease !important;
    box-sizing: border-box !important;
  }
  
  .share-container .ant-radio-wrapper:hover,
  .share-container .ant-radio-wrapper-checked {
    background: #fff !important;
    border-color: #43CE0C !important;
    box-shadow: 0 2px 8px rgba(67, 206, 12, 0.15) !important;
  }
  
  .share-container .ant-radio {
    margin-right: 12px !important;
  }
  
  /* Checkboxes optimisés */
  .share-container .ant-checkbox-group {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  .share-container .ant-checkbox-wrapper {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
    margin: 6px 0 !important;
    padding: 12px 16px !important;
    background: #f8fafc !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    font-size: 15px !important;
    transition: all 0.3s ease !important;
    box-sizing: border-box !important;
  }
  
  .share-container .ant-checkbox-wrapper:hover,
  .share-container .ant-checkbox-wrapper-checked {
    background: #fff !important;
    border-color: #43CE0C !important;
    box-shadow: 0 2px 8px rgba(67, 206, 12, 0.15) !important;
  }
  
  .share-container .ant-checkbox {
    margin-right: 12px !important;
  }
  
  /* Select dropdown optimisé */
  .share-container .ant-select {
    width: 100% !important;
  }
  
  .share-container .ant-select-selector {
    height: 44px !important;
    padding: 0 12px !important;
    display: flex !important;
    align-items: center !important;
  }
  
  /* Upload optimisé */
  .share-container .ant-upload {
    width: 100% !important;
  }
  
  .share-container .ant-upload .ant-btn {
    width: 100% !important;
    height: 44px !important;
    border-radius: 8px !important;
    border: 2px dashed #43CE0C !important;
    background: #f0f9ff !important;
    color: #43CE0C !important;
    font-weight: 500 !important;
    font-size: 15px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  /* Date et Time Pickers */
  .share-container .ant-picker {
    width: 100% !important;
    height: 44px !important;
  }
  
  /* Boutons d'action mobile */
  .share-submit-btn {
    width: 100% !important;
    height: 48px !important;
    font-size: 16px !important;
    border-radius: 10px !important;
    margin-bottom: 16px !important;
  }
  
  .share-reset-text {
    font-size: 15px !important;
    text-align: center !important;
    display: block !important;
    width: 100% !important;
  }
  
  /* Messages d'erreur optimisés */
  .share-error-message {
    color: #ef4444 !important;
    font-size: 13px !important;
    padding: 8px 12px !important;
    background: #fef2f2 !important;
    border: 1px solid #fecaca !important;
    border-radius: 6px !important;
    margin-top: 8px !important;
    animation: shake 0.5s ease-in-out !important;
  }
  
  /* Surcharge pour les éléments spécifiques des types de questions */
  .share-container input[style*="width: 56%"],
  .share-container input[style*="width:56%"] {
    width: 100% !important;
  }
  
  /* Force tous les éléments à prendre la largeur complète */
  .share-container [style*="width"] input,
  .share-container [style*="width"] .ant-input,
  .share-container [style*="width"] .ant-select,
  .share-container [style*="width"] .ant-picker {
    width: 100% !important;
  }
}

/* MOBILE PETIT (≤ 480px) */
@media (max-width: 480px) {
  .share-container {
    padding: 8px;
  }
  
  .share-form-card {
    padding: 16px 12px;
    margin-bottom: 12px;
  }
  
  .share-question-card {
    padding: 12px 10px;
    margin-bottom: 12px;
  }
  
  .titrFormulaire.ant-input {
    font-size: 18px !important;
  }
  
  .inputDescriptionTitle.ant-input {
    font-size: 13px !important;
  }
  
  .share-question-label {
    font-size: 14px !important;
  }
  
  /* Tous les inputs en petit mobile */
  .share-container .ant-input,
  .share-container .ant-input-password,
  .share-container .ant-select-selector,
  .share-container .ant-picker,
  .share-container textarea.ant-input {
    height: 40px !important;
    font-size: 15px !important;
    padding: 0 10px !important;
  }
  
  /* Textarea spécifique petit mobile */
  .share-container textarea.ant-input {
    min-height: 70px !important;
    padding: 10px !important;
  }
  
  /* Radio et checkbox petit mobile */
  .share-container .ant-radio-wrapper,
  .share-container .ant-checkbox-wrapper {
    padding: 10px 12px !important;
    font-size: 14px !important;
  }
  
  /* Upload button petit mobile */
  .share-container .ant-upload .ant-btn {
    height: 40px !important;
    font-size: 14px !important;
  }
  
  .share-submit-btn {
    height: 44px !important;
    font-size: 15px !important;
  }
  
  .share-reset-text {
    font-size: 14px !important;
  }
  
  /* Force la largeur complète même sur petit écran */
  .share-container * {
    box-sizing: border-box !important;
  }
  
  /* Surcharge spécifique pour les éléments avec style inline */
  .share-container div[style*="width"],
  .share-container span[style*="width"] {
    width: 100% !important;
  }
  
  .share-container div[style*="width"] > *,
  .share-container span[style*="width"] > * {
    width: 100% !important;
  }
}

/* Animation pour les erreurs */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-3px); }
  75% { transform: translateX(3px); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Share/Share.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,sCAAsC;AACtC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,cAAc;EAChB;;EAEA,2BAA2B;EAC3B;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA,wCAAwC;EACxC;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;EAChB;;EAEA,yBAAyB;EACzB;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,sDAAsD;EACtD;;;;;IAKE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,oCAAoC;IACpC,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B;IAC9B,oCAAoC;IACpC,iCAAiC;EACnC;;EAEA,wBAAwB;EACxB;IACE,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA,iBAAiB;EACjB;;;;;;;;;IASE,gCAAgC;IAChC,2BAA2B;IAC3B,uDAAuD;EACzD;;EAEA,4BAA4B;EAC5B;IACE,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,oCAAoC;IACpC,0BAA0B;IAC1B,oCAAoC;IACpC,iCAAiC;EACnC;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;IAChC,wDAAwD;EAC1D;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,oCAAoC;IACpC,0BAA0B;IAC1B,oCAAoC;IACpC,iCAAiC;EACnC;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;IAChC,wDAAwD;EAC1D;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,6BAA6B;EAC7B;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA,oBAAoB;EACpB;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,qCAAqC;IACrC,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,4BAA4B;EAC5B;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,gCAAgC;EAChC;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B;IAC7B,0BAA0B;IAC1B,4CAA4C;EAC9C;;EAEA,mEAAmE;EACnE;;IAEE,sBAAsB;EACxB;;EAEA,0DAA0D;EAC1D;;;;IAIE,sBAAsB;EACxB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,oCAAoC;EACpC;;;;;IAKE,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA,qCAAqC;EACrC;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA,mCAAmC;EACnC;;IAEE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA,+BAA+B;EAC/B;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,mDAAmD;EACnD;IACE,iCAAiC;EACnC;;EAEA,6DAA6D;EAC7D;;IAEE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA,+BAA+B;AAC/B;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC","sourcesContent":["/* CSS POUR LA PAGE SHARE - RESPONSIVE */\r\n\r\n/* Styles de base pour la page Share */\r\n.share-container {\r\n  background: #E8FCE2;\r\n  min-height: 100vh;\r\n  padding: 20px 0;\r\n}\r\n\r\n.share-form-container {\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Styles pour les cartes de formulaire */\r\n.share-form-card {\r\n  margin-bottom: 20px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  border-top: 6px solid #43CE0C;\r\n}\r\n\r\n.share-question-card {\r\n  margin-bottom: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\r\n  border-left: 4px solid #43CE0C;\r\n}\r\n\r\n/* Styles pour les boutons */\r\n.share-submit-btn {\r\n  padding: 12px 24px;\r\n  height: auto;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, #43CE0C 0%, #2e9e06 100%);\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  box-shadow: 0 4px 12px rgba(67, 206, 12, 0.3);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.share-submit-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(67, 206, 12, 0.4);\r\n}\r\n\r\n.share-reset-text {\r\n  color: #43CE0C;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.share-reset-text:hover {\r\n  color: #2e9e06;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* RESPONSIVE MOBILE */\r\n@media (max-width: 768px) {\r\n  .share-container {\r\n    padding: 10px;\r\n    background: #E8FCE2;\r\n  }\r\n  \r\n  .share-form-container {\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    padding: 0 8px;\r\n  }\r\n  \r\n  /* Cartes adaptées mobile */\r\n  .share-form-card {\r\n    margin-bottom: 16px;\r\n    border-radius: 12px;\r\n    padding: 20px 16px;\r\n    border-top: 8px solid #43CE0C;\r\n  }\r\n  \r\n  .share-question-card {\r\n    margin-bottom: 16px;\r\n    border-radius: 10px;\r\n    padding: 16px 12px;\r\n    border-left: 5px solid #43CE0C;\r\n  }\r\n  \r\n  /* Titre du formulaire optimisé mobile */\r\n  .titrFormulaire.ant-input {\r\n    font-size: 20px !important;\r\n    line-height: 1.3 !important;\r\n    margin-top: 0 !important;\r\n    padding: 8px 0 !important;\r\n    text-align: center;\r\n  }\r\n  \r\n  /* Description optimisée mobile */\r\n  .inputDescriptionTitle.ant-input {\r\n    font-size: 14px !important;\r\n    line-height: 1.4 !important;\r\n    text-align: center;\r\n    padding: 4px 0;\r\n  }\r\n  \r\n  /* Labels des questions */\r\n  .share-question-label {\r\n    font-size: 15px !important;\r\n    line-height: 1.4 !important;\r\n    margin-bottom: 12px !important;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  /* SURCHARGE TOUS LES INPUTS DANS LE SHARE CONTAINER */\r\n  .share-container .ant-input,\r\n  .share-container .ant-input-password,\r\n  .share-container .ant-select-selector,\r\n  .share-container .ant-picker,\r\n  .share-container textarea.ant-input {\r\n    width: 100% !important;\r\n    height: 44px !important;\r\n    border-radius: 8px !important;\r\n    border: 2px solid #e2e8f0 !important;\r\n    font-size: 16px !important;\r\n    padding: 0 12px !important;\r\n    background: #f8fafc !important;\r\n    transition: all 0.3s ease !important;\r\n    box-sizing: border-box !important;\r\n  }\r\n  \r\n  /* Textarea spécifique */\r\n  .share-container textarea.ant-input {\r\n    min-height: 80px !important;\r\n    padding: 12px !important;\r\n    resize: vertical !important;\r\n  }\r\n  \r\n  /* Focus states */\r\n  .share-container .ant-input:focus,\r\n  .share-container .ant-input:hover,\r\n  .share-container .ant-input-password:focus,\r\n  .share-container .ant-input-password:hover,\r\n  .share-container .ant-select-focused .ant-select-selector,\r\n  .share-container .ant-picker:hover,\r\n  .share-container .ant-picker-focused,\r\n  .share-container textarea.ant-input:focus,\r\n  .share-container textarea.ant-input:hover {\r\n    border-color: #43CE0C !important;\r\n    background: #fff !important;\r\n    box-shadow: 0 0 0 3px rgba(67, 206, 12, 0.1) !important;\r\n  }\r\n  \r\n  /* Radio buttons optimisés */\r\n  .share-container .ant-radio-group {\r\n    width: 100% !important;\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n  }\r\n  \r\n  .share-container .ant-radio-wrapper {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    width: 100% !important;\r\n    margin: 6px 0 !important;\r\n    padding: 12px 16px !important;\r\n    background: #f8fafc !important;\r\n    border-radius: 8px !important;\r\n    border: 1px solid #e2e8f0 !important;\r\n    font-size: 15px !important;\r\n    transition: all 0.3s ease !important;\r\n    box-sizing: border-box !important;\r\n  }\r\n  \r\n  .share-container .ant-radio-wrapper:hover,\r\n  .share-container .ant-radio-wrapper-checked {\r\n    background: #fff !important;\r\n    border-color: #43CE0C !important;\r\n    box-shadow: 0 2px 8px rgba(67, 206, 12, 0.15) !important;\r\n  }\r\n  \r\n  .share-container .ant-radio {\r\n    margin-right: 12px !important;\r\n  }\r\n  \r\n  /* Checkboxes optimisés */\r\n  .share-container .ant-checkbox-group {\r\n    width: 100% !important;\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n  }\r\n  \r\n  .share-container .ant-checkbox-wrapper {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    width: 100% !important;\r\n    margin: 6px 0 !important;\r\n    padding: 12px 16px !important;\r\n    background: #f8fafc !important;\r\n    border-radius: 8px !important;\r\n    border: 1px solid #e2e8f0 !important;\r\n    font-size: 15px !important;\r\n    transition: all 0.3s ease !important;\r\n    box-sizing: border-box !important;\r\n  }\r\n  \r\n  .share-container .ant-checkbox-wrapper:hover,\r\n  .share-container .ant-checkbox-wrapper-checked {\r\n    background: #fff !important;\r\n    border-color: #43CE0C !important;\r\n    box-shadow: 0 2px 8px rgba(67, 206, 12, 0.15) !important;\r\n  }\r\n  \r\n  .share-container .ant-checkbox {\r\n    margin-right: 12px !important;\r\n  }\r\n  \r\n  /* Select dropdown optimisé */\r\n  .share-container .ant-select {\r\n    width: 100% !important;\r\n  }\r\n  \r\n  .share-container .ant-select-selector {\r\n    height: 44px !important;\r\n    padding: 0 12px !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n  }\r\n  \r\n  /* Upload optimisé */\r\n  .share-container .ant-upload {\r\n    width: 100% !important;\r\n  }\r\n  \r\n  .share-container .ant-upload .ant-btn {\r\n    width: 100% !important;\r\n    height: 44px !important;\r\n    border-radius: 8px !important;\r\n    border: 2px dashed #43CE0C !important;\r\n    background: #f0f9ff !important;\r\n    color: #43CE0C !important;\r\n    font-weight: 500 !important;\r\n    font-size: 15px !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n  }\r\n  \r\n  /* Date et Time Pickers */\r\n  .share-container .ant-picker {\r\n    width: 100% !important;\r\n    height: 44px !important;\r\n  }\r\n  \r\n  /* Boutons d'action mobile */\r\n  .share-submit-btn {\r\n    width: 100% !important;\r\n    height: 48px !important;\r\n    font-size: 16px !important;\r\n    border-radius: 10px !important;\r\n    margin-bottom: 16px !important;\r\n  }\r\n  \r\n  .share-reset-text {\r\n    font-size: 15px !important;\r\n    text-align: center !important;\r\n    display: block !important;\r\n    width: 100% !important;\r\n  }\r\n  \r\n  /* Messages d'erreur optimisés */\r\n  .share-error-message {\r\n    color: #ef4444 !important;\r\n    font-size: 13px !important;\r\n    padding: 8px 12px !important;\r\n    background: #fef2f2 !important;\r\n    border: 1px solid #fecaca !important;\r\n    border-radius: 6px !important;\r\n    margin-top: 8px !important;\r\n    animation: shake 0.5s ease-in-out !important;\r\n  }\r\n  \r\n  /* Surcharge pour les éléments spécifiques des types de questions */\r\n  .share-container input[style*=\"width: 56%\"],\r\n  .share-container input[style*=\"width:56%\"] {\r\n    width: 100% !important;\r\n  }\r\n  \r\n  /* Force tous les éléments à prendre la largeur complète */\r\n  .share-container [style*=\"width\"] input,\r\n  .share-container [style*=\"width\"] .ant-input,\r\n  .share-container [style*=\"width\"] .ant-select,\r\n  .share-container [style*=\"width\"] .ant-picker {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n/* MOBILE PETIT (≤ 480px) */\r\n@media (max-width: 480px) {\r\n  .share-container {\r\n    padding: 8px;\r\n  }\r\n  \r\n  .share-form-card {\r\n    padding: 16px 12px;\r\n    margin-bottom: 12px;\r\n  }\r\n  \r\n  .share-question-card {\r\n    padding: 12px 10px;\r\n    margin-bottom: 12px;\r\n  }\r\n  \r\n  .titrFormulaire.ant-input {\r\n    font-size: 18px !important;\r\n  }\r\n  \r\n  .inputDescriptionTitle.ant-input {\r\n    font-size: 13px !important;\r\n  }\r\n  \r\n  .share-question-label {\r\n    font-size: 14px !important;\r\n  }\r\n  \r\n  /* Tous les inputs en petit mobile */\r\n  .share-container .ant-input,\r\n  .share-container .ant-input-password,\r\n  .share-container .ant-select-selector,\r\n  .share-container .ant-picker,\r\n  .share-container textarea.ant-input {\r\n    height: 40px !important;\r\n    font-size: 15px !important;\r\n    padding: 0 10px !important;\r\n  }\r\n  \r\n  /* Textarea spécifique petit mobile */\r\n  .share-container textarea.ant-input {\r\n    min-height: 70px !important;\r\n    padding: 10px !important;\r\n  }\r\n  \r\n  /* Radio et checkbox petit mobile */\r\n  .share-container .ant-radio-wrapper,\r\n  .share-container .ant-checkbox-wrapper {\r\n    padding: 10px 12px !important;\r\n    font-size: 14px !important;\r\n  }\r\n  \r\n  /* Upload button petit mobile */\r\n  .share-container .ant-upload .ant-btn {\r\n    height: 40px !important;\r\n    font-size: 14px !important;\r\n  }\r\n  \r\n  .share-submit-btn {\r\n    height: 44px !important;\r\n    font-size: 15px !important;\r\n  }\r\n  \r\n  .share-reset-text {\r\n    font-size: 14px !important;\r\n  }\r\n  \r\n  /* Force la largeur complète même sur petit écran */\r\n  .share-container * {\r\n    box-sizing: border-box !important;\r\n  }\r\n  \r\n  /* Surcharge spécifique pour les éléments avec style inline */\r\n  .share-container div[style*=\"width\"],\r\n  .share-container span[style*=\"width\"] {\r\n    width: 100% !important;\r\n  }\r\n  \r\n  .share-container div[style*=\"width\"] > *,\r\n  .share-container span[style*=\"width\"] > * {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n/* Animation pour les erreurs */\r\n@keyframes shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  25% { transform: translateX(-3px); }\r\n  75% { transform: translateX(3px); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
